import React, { useEffect, useRef } from 'react';
import './ClassMemo.css';

/** 반 화면 하단 시트. 닫기는 × 버튼·바깥 누르기·Esc(끌어 내리기 손잡이는 두지 않는다). */
const ClassSheet = ({ title, subtitle, onClose, children, footer, testId }) => {
  const panelRef = useRef(null);

  useEffect(() => {
    const onKey = (event) => { if (event.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    const { overflow } = document.body.style;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = overflow;
    };
  }, [onClose]);

  return (
    <div className="class-sheet-root">
      <div className="class-sheet-scrim" onClick={onClose} aria-hidden="true" />
      <section ref={panelRef} className="class-sheet" role="dialog" aria-modal="true" aria-label={title} data-testid={testId}>
        <header className="class-sheet-head">
          <div>
            <h2>{title}</h2>
            {subtitle && <p>{subtitle}</p>}
          </div>
          <button type="button" className="class-sheet-close" aria-label="닫기" onClick={onClose}>×</button>
        </header>
        <div className="class-sheet-body">{children}</div>
        {footer && <footer className="class-sheet-foot">{footer}</footer>}
      </section>
    </div>
  );
};

export default ClassSheet;
